import React, {useCallback, useEffect, useRef, useState} from 'react'
import {reduxForm, reset} from 'redux-form'
import {Card} from 'react-bootstrap'
import Button from '@material-ui/core/Button'
import NotInterestedOutlinedIcon from '@material-ui/icons/NotInterestedOutlined';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import SecurityOutlinedIcon from '@material-ui/icons/SecurityOutlined';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import HowToRegOutlinedIcon from '@material-ui/icons/HowToRegOutlined';
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import {cloneDeep} from 'lodash'
import FilterBarModule from "components/shared/FilterBarModule"
import TableComponent from 'components/shared/TableComponent'
import {Tab, Tabs} from 'components/shared/Tabs'
import {Toast} from 'components/shared/Toaster'
import {
  clientSettingsTab,
  EXEMPT_BY_ACCOUNT_TYPE,
  salesRepresentativeColumns,
  templateColumns as template_columns,
  templateFilter,
  userColumns,
  userFilter,
  creditMemoApproverFilter
} from 'constants/roxAdminSettings'
import {ClientForm, DocuSignForm, TaxRockForm, SalesRepresentativeForm, TemplateForm, UserForm} from '../DialogForms'
import {getValue} from 'tools/helper'
import AuthService from 'tools/AuthService'
import strings from 'strings'
import EditIcon from 'styles/images/icons/tableedit.svg'
import DeleteIcon from 'styles/images/icons/tableDelete.svg'
import styles from './profile.module.scss'
import NotificationForm from './partial/notificationForm';
import FeatureFlagsForm from './partial/MarketplaceForm';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { callBackDocusign } from 'actions/user';
import ReportsCostDialog from './partial/reportsCostDialog';
import BillingTab from './partial/billingTab';
import request from "../../../tools/request";
import StripeConfirmationModal from "./partial/stripeConfirmationModal";
import HubSpotForm from '../DialogForms/HubSpotForm';
import UnderwritingForm from '../DialogForms/UnderwritingForm';
import ClientPortalTab from "./ClientPortal/ClientPortalTab";
import DocusignTemplatesTab from "./DocusignTemplates/DocusignTemplatesTab";
import ClientInformationTab from "./partial/ClientInformationTab";
import SecurityTab from "./partial/SecurityTab";
import FlaggedBusinessTypesTab from "./partial/FlaggedBusinessTypesTab";
import ClientFeatureFlagsTab from "./partial/ClientFeatureFlagsTab";
import ClientPlaidConfigTab from "./partial/ClientPlaidConfigTab";
import PlaidConnectionsTab from "./partial/PlaidConnectionsTab";
import DeclineEmailSettingsTab from './partial/DeclineEmailSettingsTab';
import ConfirmationDialog from "components/ConfirmationDialog";
import SharedApplicationsModal from './partial/SharedApplicationsModal';

const t = strings.CUSTOMER_PROFILE_STRING

const ClientProfile = (props) => {
  const {
    initialValues,
    handleSubmit, // redux prop passed from container to handle submit form
    customerData, // customer data passed from container
    usersList, // user list data passed from container
    clientId, // action to get clientId from params
    getClientById, //action to get client data by ID
    updateClient, //action to update client by ID
    getUsersList, // action to get users list
    createUser, // action to create user
    updateUser,
    toggleUser, // action to enable or disable a user
    updateTwoFactorExemption, // action to grant or revoke a user's two-factor exemption
    updateCreditMemoApprover, // action to grant or revoke the credit memo approver role
    dispatchProcessing, // action to show loader
    dispatchFormConfig, // action to set default form value
    totalRecords,
    totalPages,
    dispatch,
    getTemplates,
    getRolesList,
    getSalesRepresentatives,
    createSalesRepresentatives,
    updateSalesRepresentatives,
    deleteSalesRepresentatives,
    salesRepresentativeList,
    salesRepresentativeTotalPages,
    salesRepresentativeTotalRecords,
    createTemplate,
    updateTemplate,
    templateList, // template list and headers
    templateTotalRecords,
    templateTotalPages,
    match
  } = props
  const isReadOnlyuser = AuthService.isReadOnlyUser()
  const canManageUsers = !isReadOnlyuser && AuthService.canManageUsers()
  const [columns, setColumns] = useState(() => {
    const action = {
      formatter: (cell, row, rowIndex) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px', flexWrap: 'nowrap' }}>
          <span className='rounded-icons'>
            {row.status === 'Active' ?
              <NotInterestedOutlinedIcon titleAccess='Disable' color='secondary' onClick={() => enableOrDisableUser(row)} />
              :
              <PersonOutlinedIcon titleAccess='Enable' onClick={() => enableOrDisableUser(row)} />}
          </span>
          {!EXEMPT_BY_ACCOUNT_TYPE.includes(row.type) &&
            <span className='rounded-icons'>
              <SecurityOutlinedIcon
                color={row.twoFactorExempt ? 'secondary' : 'primary'}
                titleAccess={row.twoFactorExempt
                  ? 'Require two-factor authentication'
                  : 'Exempt from two-factor authentication'}
                onClick={() => askTwoFactorExemption(row)} />
            </span>}
          <span className='rounded-icons'>
            <SettingsOutlinedIcon
              color='primary'
              titleAccess='edit'
              onClick={() => handleUserEditForm(row)} />
          </span>
        </div>
      )
    }
    if (canManageUsers)
      userColumns.map((item, index) => {
        if (item.dataField === 'action') {
          userColumns[index] = { ...item, ...action }
        }
        return item
      })
    return userColumns
  })


  const {
    docusignEnabled,
    taxrockEnabled,
    creditUsageEnabled,
    hubSpotIntegrationEnabled,
    marketplaceEnabled,
    activityDashboardEnabled,
    applicationDeclineEmailEnabled,
    applicationFlaggingEnabled,
  } = AuthService.getClientFeatures()
  const admin = AuthService.hasRole(strings.ROX_ADMIN)
  const customerAdmin = AuthService.hasRole(strings.CUSTOMER_ADMIN)

  if(!creditUsageEnabled){
    if(clientSettingsTab.some(tab => tab.label === 'Billing')){
      const index = clientSettingsTab.findIndex(tab => tab.label === 'Billing');
      clientSettingsTab.splice(index, 1);
    }
    if(clientSettingsTab.some(tab => tab.label === 'Billing')){
      const index = clientSettingsTab.findIndex(tab => tab.label === 'Billing');
      clientSettingsTab.splice(index, 1);
    }
  }
  const hasRoxAdminRole = AuthService.hasRole(strings.ROX_ADMIN) // checks whether user has ROX_ADMIN Role
  const hasViewNotificationPrivileges = AuthService.hasPrivilege("MANAGE_CLIENT_NOTIFICATION_SETTINGS")
  // Two-factor requirement of one's own client. Hidden from the rox admin like Client
  // Information is: clients/me/security-settings resolves the client from the token, so from
  // here it would edit the admin's own client instead of the one being viewed.
  const canManageSecuritySettings = AuthService.hasAnyPrivilege("MANAGE_CLIENT_USER", "MANAGE_USER", "MANAGE_CLIENT")
  // 'docusingEnabled' is the (misspelled) client flag returned by GET clients/{uuid}
  const clientDocusignEnabled = !!customerData?.docusingEnabled
  const showDocusignTemplates = admin && clientDocusignEnabled


  useEffect(() => {
    if (hasRoxAdminRole && clientSettingsTab.some(tab => tab.label === 'Client Information')) {
      const index = clientSettingsTab.findIndex(tab => tab.label === 'Client Information');
      clientSettingsTab.splice(index, 1);
    }
    if (hasViewNotificationPrivileges && !hasRoxAdminRole && !clientSettingsTab.some(tab => tab.label === 'Notifications')) {
      clientSettingsTab.push({ label: 'Notifications' });
    }
    if (applicationDeclineEmailEnabled && hasViewNotificationPrivileges && !hasRoxAdminRole
        && !clientSettingsTab.some(tab => tab.label === 'Decline Email')) {
      clientSettingsTab.push({ label: 'Decline Email' });
    }

    if (docusignEnabled && !clientSettingsTab.some(tab => tab.label === 'Docusign')) {
      clientSettingsTab.push({ label: 'Docusign' });
    }

    if (taxrockEnabled && !clientSettingsTab.some(tab => tab.label === 'TaxRock')) {
      clientSettingsTab.push({ label: 'TaxRock' });
    }

    if (hubSpotIntegrationEnabled && !clientSettingsTab.some(tab => tab.label === 'HubSpot')) {
      clientSettingsTab.push({ label: 'HubSpot' });
    }

    if (marketplaceEnabled && !clientSettingsTab.some(tab => tab.label === 'MarketPlace')) {
      clientSettingsTab.push({ label: 'MarketPlace' });
    }

    if (admin && !clientSettingsTab.some(tab => tab.label === 'Client Portal')) {
      clientSettingsTab.push({ label: 'Client Portal' });
    }

    // Feature flags are managed through the admin-only clients/feature-flags endpoints
    if (admin && !clientSettingsTab.some(tab => tab.label === 'Feature Flags')) {
      clientSettingsTab.push({ label: 'Feature Flags' });
    }

    // Plaid page branding is managed through the admin-only admin/client-plaid-config endpoints
    if (admin && !clientSettingsTab.some(tab => tab.label === 'Plaid Page')) {
      clientSettingsTab.push({ label: 'Plaid Page' });
    }

    if (admin && !clientSettingsTab.some(tab => tab.label === 'Plaid Connections')) {
      clientSettingsTab.push({ label: 'Plaid Connections' });
    }

    // the flag belongs to the client being edited, not to the logged in user's client,
    // and it arrives with customerData, so the tab is added or removed as it resolves
    const docusignTemplatesIndex = clientSettingsTab.findIndex(tab => tab.label === 'Docusign Templates');
    if (showDocusignTemplates && docusignTemplatesIndex === -1) {
      clientSettingsTab.push({ label: 'Docusign Templates' });
    } else if (!showDocusignTemplates && docusignTemplatesIndex !== -1) {
      clientSettingsTab.splice(docusignTemplatesIndex, 1);
    }

    if (activityDashboardEnabled && !clientSettingsTab.some(tab => tab.label === 'Underwriting')) {
      clientSettingsTab.push({ label: 'Underwriting' });
    }

    if (canManageSecuritySettings && !hasRoxAdminRole && !clientSettingsTab.some(tab => tab.label === 'Security')) {
      clientSettingsTab.push({ label: 'Security' });
    }

    if (applicationFlaggingEnabled && canManageSecuritySettings && !hasRoxAdminRole && !clientSettingsTab.some(tab => tab.label === 'Flagging')) {
      clientSettingsTab.push({ label: 'Flagging' });
    }
  }, [docusignEnabled, taxrockEnabled, hubSpotIntegrationEnabled, marketplaceEnabled, hasViewNotificationPrivileges, hasRoxAdminRole, activityDashboardEnabled, showDocusignTemplates, canManageSecuritySettings, applicationFlaggingEnabled])




  const { tab } = useParams();
  const history = useHistory();
  const taxrockToastShownRef = useRef(false);
  const location = useLocation();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const notificationTabIndex = clientSettingsTab.findIndex(tab =>
      tab.label === 'Notification' || tab.label === 'Notifications'
  );

  const query = useQuery();
  const code = query.get('code');
  const tabFromQuery = query.get('tab');
  const taxrockConnected = query.get('taxrock');

useEffect(() => {
  if (tab) {
    const docusignTabIndex = clientSettingsTab.findIndex(t =>
      t.label.toLowerCase() === 'docusign'
    );

    if (docusignTabIndex !== -1 && tab.toLowerCase() === 'docusign') {
      if (code) {
        callBackDocusign(code).then((res) => {
          if (res?.status === 200) {
            Toast({ type: 'success', message: strings.SETTINGS_FORM.DOCUSIGN_FORM })
          } else {
            Toast({ type: 'error', message: strings.SETTINGS_FORM.DOCUSIGN_ERROR })
          }
        })
      }
      setTabValue(docusignTabIndex);
    }
    else if (tab.toLowerCase() === 'taxrock') {
      const taxrockTabIndex = clientSettingsTab.findIndex(t =>
        t.label.toLowerCase() === 'taxrock'
      );
      if (taxrockTabIndex !== -1) {
        if (taxrockConnected === 'connected' && !taxrockToastShownRef.current) {
          taxrockToastShownRef.current = true;
          Toast({ type: 'success', message: 'TaxRock connected successfully.' })
          // Consume the query param so a refresh (or effect re-run) doesn't re-toast.
          history.replace('/settings/taxrock');
        }
        setTabValue(taxrockTabIndex);
      }
    }
    else if (notificationTabIndex !== -1 &&
             clientSettingsTab[notificationTabIndex]?.label.toLowerCase() === tab.toLowerCase()) {
      setTabValue(notificationTabIndex);
    }
    else {
      setTabValue(creditUsageEnabled ? 3 : 0);
    }
  } else if (tabFromQuery) {
    const foundIndex = clientSettingsTab.findIndex(t =>
      t.label.toLowerCase().replace(/ /g, '-') === tabFromQuery.toLowerCase()
    );
    if (foundIndex !== -1) setTabValue(foundIndex);
    else setTabValue(creditUsageEnabled ? 3 : 0);
  } else {
    setTabValue(creditUsageEnabled ? 3 : 0);
  }
// showDocusignTemplates is included because that tab only exists once customerData resolves,
// so a ?tab=docusign-templates deep link has to be re-resolved when it gets added
}, [tab, code, tabFromQuery, taxrockConnected, notificationTabIndex, showDocusignTemplates])





  // Read by the row formatter at render time: the client's flags can arrive after the columns are built
  const salesRepUsersRef = useRef(false)
  salesRepUsersRef.current = customerData?.featureFlags
    ? customerData.featureFlags.includes('SALES_REP_USERS')
    : AuthService.getClientFeatures().salesRepUsersEnabled

  // The sales representative whose shared applications are listed in a dialog
  const [sharedWithRepresentative, setSharedWithRepresentative] = useState(null)

  const [representativeColumns, setRepresentativeColumns] = useState(() => {
    const action = {
      formatter: (cell, row, rowIndex) => (
        <div className={styles.representativeActions}>
          {salesRepUsersRef.current && (row.hasLogin
            ? <Tooltip title='Has a login (see the User tab)'>
                <HowToRegOutlinedIcon className={styles.hasLoginIcon} />
              </Tooltip>
            : row.emailInUse
              ? <Tooltip title='Another user already has this email, so no Sales Rep login can be created for it'>
                  <PersonAddOutlinedIcon className={styles.hasLoginIcon} aria-label='Email already in use' />
                </Tooltip>
              : <Tooltip title='Create a Sales Rep login for this person'>
                  <IconButton
                    aria-label={`Create a Sales Rep login for ${row.firstName} ${row.lastName}`}
                    className={styles.createLoginButton}
                    onClick={() => handleRepresentativeCreateLogin(row)}
                  >
                    <PersonAddOutlinedIcon className={styles.createLoginIcon} />
                  </IconButton>
                </Tooltip>
          )}
          <img src={EditIcon} onClick={() => handleRepresentativeEditForm(row)} title='edit' alt='edit' />
          {row.hasLogin
            ? <Tooltip title='Has a login. To remove them, deactivate their user in the User tab.'>
                <img src={DeleteIcon} className={styles.actionDisabled} alt='delete' />
              </Tooltip>
            : <img src={DeleteIcon} onClick={() => handleRepresentativeDeleteForm(row)} title='Delete' alt='delete' />
          }
        </div>
      )
    }
    // How many applications are shared with their login; the count opens the list
    const sharedApplications = {
      formatter: (cell, row) => {
        if (!row.hasLogin) return <span className={styles.mutedCell}>{row.emailInUse ? 'Email in use' : 'No login'}</span>
        if (!cell) return <span className={styles.mutedCell}>None</span>
        return (
          <button type='button' className={styles.linkButton} onClick={() => setSharedWithRepresentative(row)}>
            {cell} {cell === 1 ? 'application' : 'applications'}
          </button>
        )
      }
    }
    if (!isReadOnlyuser)
      cloneDeep(salesRepresentativeColumns).map((item, index) => {
        if (item.dataField === 'action') {
          salesRepresentativeColumns[index] = { ...item, ...action }
        }
        if (item.dataField === 'sharedApplications') {
          salesRepresentativeColumns[index] = { ...item, ...sharedApplications }
        }
        return item
      })
    return salesRepresentativeColumns
  })
  const [templateColumns, setTemplateColumns] = useState(() => {
    const filingAction = {
      formatter: (cell, row, rowIndex) => {
        return (
          <>
            {/* TODO Need API to perform tis action */}
            {/* <img src={EditIcon} style={{ height: '40px' }} title='Edit' alt='edit' />
            <img src={DeleteIcon} title='Delete' alt='delete' /> */}
          </>
        )
      }
    }
    if (!isReadOnlyuser)
      template_columns.map((item, index) => {
        if (item.dataField === 'action') {
          template_columns[index] = { ...item, ...filingAction }
        }
        return item
      })
    return template_columns
  })
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState({
    clientForm: false,
    userForm: false,
    templateForm: false,
    salesRepresentativeForm: false,
    docuSignForm: false,
    reportsCostDialog: false
  })
  // Pending two-factor exemption change. Exempting an account lowers its security, so it is
  // confirmed instead of toggled straight from the row.
  const [twoFactorDialog, setTwoFactorDialog] = useState({ open: false, user: null })
  const [formMode, setFormMode] = useState(strings.CREATE)
  const [formLoader, setFormLoader] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [clientID, setClientID] = useState()
  // Only the self-signup onboarding checkout returns to `.../showConfirmation/onboarding`
  // and shows the onboarding confirmation modal. In-app upgrades return to `.../true`
  // (or `.../upgrade`) and must NOT show it.
  const [openStripeConfirmationModal, setOpenStripeConfirmationModal] = useState(match.params.subConfirmation === "onboarding")
  // Bumped whenever the confirmation modal changes billing state (subscription
  // activated / credits added) so BillingTab re-fetches its plan + usage.
  const [billingRefreshKey, setBillingRefreshKey] = useState(0)
  const [tiers,setTiers] = useState()

  const [autoReplenish, setAutoReplenish] = useState({
    enabled: false,
    thresholdCredits: 100,
    purchaseCredits: 500,
  });
  const [, setSelectedTier] = useState(null);
  const [, setChangeTierDialogOpen] = useState(false);
  const [, setAutoReplenishDialogOpen] = useState(false);

  /**
   * function to call client API by ID and users list API
   * For platform admin it will call both getClientById and getUsersList API but for customer admin it will call only usersList API
   */
  const loadData = useCallback((filters = {}, pagination = {}) => {
    dispatchProcessing(true)
    if (hasRoxAdminRole) {
      getClientById(clientId).then((res) => {
        if (res?.clientId >= 0) {
          setClientID(res.clientId)
          getUsersList(filters, pagination, res.clientId, res.uuid).finally(() => {
            dispatchProcessing(false)
            setLoading(false)
          })
        }
      })
    } else {
      getUsersList(filters, pagination).finally(() => {
        dispatchProcessing(false)
        setLoading(false)
      })
    }
  }, [getClientById, dispatchProcessing, clientId, getUsersList, hasRoxAdminRole])

  const getRepresentativeList = useCallback((pagination) => {
    dispatchProcessing(true)
    getSalesRepresentatives(pagination).finally(() => dispatchProcessing(false))
  }, [dispatchProcessing, getSalesRepresentatives])

  const getTemplateList = useCallback((pagination) => {
    dispatchProcessing(true)
    getTemplates(pagination, clientID).finally(() => dispatchProcessing(false))
    // eslint-disable-next-line
  }, [getTemplates, dispatchProcessing])

  const getTiersFromStripe = useCallback(() => {
    request('stripe/read/subscriptionProducts', 'GET').then((response) =>{
      setTiers(response);
    });
  }, [])


  useEffect(() => {
    switch (tabValue) {
      case 0:
        loadData()
        break;
      case 1:
        getRepresentativeList()
        break;
      case 2:
        getTemplateList()
        break;
      case 3:
        getTiersFromStripe()
        break;
      default:
        loadData()
        break;
    }
  }, [loadData, getRepresentativeList, getTemplateList, tabValue])

  useEffect(() => {
    if (!isReadOnlyuser)
      getRolesList()
  }, [getRolesList, isReadOnlyuser])

  const handleUserEditForm = (row) => {
    dispatchFormConfig({
      type: strings.SETTINGS_FORM.USER_EDIT_FORM,
      id: row?.userId
    })
    setModal({
      ...modal,
      userForm: true
    })
    setFormMode(strings.EDIT)
  }

  // Filters from the filter panel and the search box, plus the current page. Kept in refs, not state:
  // FilterBarModule builds its debounced search callback once, so a closure over state would go stale,
  // and refs let every reload (paging, edits, enable/disable) reuse what is currently applied.
  const userFiltersRef = useRef({})
  const userSearchRef = useRef('')
  const userPaginationRef = useRef({})
  const activeUserFilters = (filters = userFiltersRef.current, search = userSearchRef.current) => {
    const query = {}
    const name = (search || filters.name || '').trim()
    if (name) query.name = name
    if (filters.creditMemoApprover !== undefined && filters.creditMemoApprover !== null && filters.creditMemoApprover !== '') {
      query.creditMemoApprover = filters.creditMemoApprover
    }
    return query
  }
  const handleUserFilters = (filters) => {
    userFiltersRef.current = filters || {}
    userPaginationRef.current = {}
    loadData(activeUserFilters())
  }
  const handleUserSearch = (search) => {
    userSearchRef.current = search || ''
    userPaginationRef.current = {}
    loadData(activeUserFilters())
  }
  const reloadUsers = () => loadData(activeUserFilters(), userPaginationRef.current)
  const userClientHasApproval = customerData?.featureFlags
    ? customerData.featureFlags.includes('CREDIT_MEMO_APPROVAL')
    : AuthService.getClientFeatures().creditMemoApprovalEnabled

  const handlePagination = (pagination) => {
    userPaginationRef.current = pagination || {}
    loadData(activeUserFilters(), pagination)
  }

  const handleUser = () => {
    dispatchFormConfig({
      type: strings.SETTINGS_FORM.USER_CREATE_FORM
    })
    setModal({ ...modal, userForm: true })
    setFormMode(strings.CREATE)
  }

  const handleSalesRepresentative = () => {
    dispatchFormConfig({ type: strings.SETTINGS_FORM.ADD_SALES_REPRESENTATIVE })
    setModal({ ...modal, salesRepresentativeForm: true })
    setFormMode(strings.CREATE)
  }

  const handleTemplate = () => {
    dispatchFormConfig({
      type: strings.SETTINGS_FORM.USER_CREATE_TEMPLATE
    })
    setModal({ ...modal, templateForm: true })
    setFormMode(strings.CREATE)
  }

  const handleClientUpdateForm = (formData) => {
    let data = {}
    Object.entries(formData.client).forEach(entries => {
      data[entries[0]] = entries[1]
    })

    // Transform featureFlags from object to array. The form only renders a subset of the
    // flags, and the backend replaces the whole set on patch, so any flag the form does not
    // carry is preserved explicitly: dropping one here would silently turn it off, and
    // TWO_FACTOR_REQUIRED is one of them.
    const submittedFlags = data.featureFlags || {};
    data.featureFlags = [
      ...Object.entries(submittedFlags).filter(([, value]) => value).map(([key]) => key),
      ...(customerData?.featureFlags || []).filter(flag => !(flag in submittedFlags))
    ];

    setFormLoader(true)
    updateClient(data)
        .then(() => {
          setFormLoader(false);
          setModal({ ...modal, clientForm: false });
          loadData();
        })
        .finally(() => {
          setFormLoader(false);
        });
  }

  const handleUserForm = (formData) => {
    const formAction = formMode === strings.CREATE ? createUser : updateUser // TODO need to implement update API for now using createAPI
    const { creditMemoApprover, ...userData } = formData
    // Approver is its own endpoint so it never replaces the user's main role.
    const approverChanged = formMode !== strings.CREATE && userData.userId
      && Boolean(creditMemoApprover) !== Boolean(initialValues?.creditMemoApprover)
    setFormLoader(true)
    formAction({ ...userData, clientId }, customerData?.clientId)
      .then(() => approverChanged && updateCreditMemoApprover(userData.userId, Boolean(creditMemoApprover), customerData?.clientId))
      .finally(() => {
      reloadUsers()
      // A login created from the Sales Representative tab: refresh it so the row shows it has one
      if (tabValue === 1) getRepresentativeList()
      dispatch(reset('profileForm'))
      setModal({ ...modal, userForm: false })
      setLoading(false)
      setFormLoader(false)
    })
  }

  const handleSalesRepresentativeForm = (formData = {}) => {
    setFormLoader(true)
    delete formData.is_superuser
    delete formData.userRol
    delete formData.uuid
    delete formData.createdBy
    delete formData.hasLogin
    delete formData.sharedApplications
    delete formData.emailInUse

    const formAction = formMode === strings.CREATE ? createSalesRepresentatives :
      formMode === strings.EDIT ? updateSalesRepresentatives :
        deleteSalesRepresentatives
    formAction(formData, initialValues?.uuid).then(() => {
      getRepresentativeList();
      Toast({ type: 'success', message: formMode === strings.DELETE ? strings.APPLICANT.ATTACHMENTS.DELETE_MSG : strings.SUCCESS })
    }).finally(() => {
      dispatch(reset('profileForm'))
      setModal({ ...modal, salesRepresentativeForm: false })
      setFormLoader(false)
    })
  }

  const handleRepresentativeEditForm = (row) => {
    setModal({ ...modal, salesRepresentativeForm: true })
    setFormMode(strings.EDIT)
    dispatchFormConfig({
      id: row?.uuid,
      type: strings.SETTINGS_FORM.EDIT_SALES_REPRESENTATIVE,
    })
  }

  // Opens Create User filled in from the sales representative, with the Sales Rep role
  const handleRepresentativeCreateLogin = (row) => {
    dispatchFormConfig({
      type: strings.SETTINGS_FORM.USER_FROM_SALES_REPRESENTATIVE,
      id: row?.uuid
    })
    setModal({ ...modal, userForm: true })
    setFormMode(strings.CREATE)
  }

  const handleRepresentativeDeleteForm = (row) => {
    // TODO: Add confirm dialog before delete
    // setModal({ ...modal, salesRepresentativeForm: true })
    // setFormMode(strings.DELETE)
    // dispatchFormConfig({
    //   id: row?.uuid,
    //   type: strings.SETTINGS_FORM.EDIT_SALES_REPRESENTATIVE,
    // })

    // Can be deleted once confirmation dialog is implemeted
    deleteSalesRepresentatives(row.uuid).then(() => {
      getRepresentativeList();
      Toast({ type: 'success', message: strings.APPLICANT.ATTACHMENTS.DELETE_MSG })
    })
  }

  const handlTemplateForm = (formData) => {
    const formAction = formMode === strings.CREATE ? createTemplate : updateTemplate // TODO need to implement update API
    setFormLoader(true)
    formAction(formData).then(() => {
      getTemplateList();
      Toast({ type: 'success', message: strings.SETTINGS_FORM.TEMPLATE.SUCCESS_MSG })
    }).finally(() => {
      setModal({ ...modal, templateForm: false })
      setFormLoader(false)
    })
  }

  const handleChange = (e, val) => {
    setTabValue(val);
    const tabLabel = clientSettingsTab[val]?.label;
    if (tabLabel) {
      const params = new URLSearchParams(location.search);
      params.set('tab', tabLabel.toLowerCase().replace(/ /g, '-'));
      params.delete('config');
      history.replace({ search: params.toString() });
    }
  }

  const enableOrDisableUser = ({ userId, status }) => {
    const active = status === 'Active' ? true : false
    setLoading(true)
    toggleUser(userId, active)
      .then(() => {
        reloadUsers()
        setLoading(false)
      })
      .catch(() => {
        setLoading(false);
      })
  }

  const askTwoFactorExemption = (user) => {
    setTwoFactorDialog({ open: true, user })
  }

  const confirmTwoFactorExemption = () => {
    const { user } = twoFactorDialog
    if (!user) return
    setLoading(true)
    updateTwoFactorExemption(user.userId, !user.twoFactorExempt)
      .then(() => {
        setTwoFactorDialog({ open: false, user: null })
        reloadUsers()
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const handleAutoReplenishToggle = (enabled) => {
    if (enabled) {
      setAutoReplenishDialogOpen(true);
    } else {
      setAutoReplenish(prev => ({ ...prev, enabled: false }));
    }
  };
  const handleTierChange = (tier) => {
    setSelectedTier(tier);
    setChangeTierDialogOpen(true);
  };

  /**
   * customer profile data build with API response
   */
  const customerProfileData = {
    [t.CUSTOMER_NAME]: getValue(customerData?.name),
    [t.CUSTOMER_BUSINESS_TYPE]: getValue(customerData?.businessType),
    [t.CUSTOMER_PHONE]: getValue(customerData?.phone),
    [t.NO_OF_USERS]: `${usersList?.length} ${strings.USER}`
  }

  return (
    <div>
      <h4>{strings.SETTINGS}</h4>
      <Tabs
        data={clientSettingsTab}
        value={tabValue}
        onChange={handleChange}
        scrollable
      />
      {
        hasRoxAdminRole && tabValue !== 3 && (
          <Card>
            <div className={styles.profileContainer}>
              <div className={styles.profileHeader}>
                <h5>{strings.CUSTOMER_PROFILE}</h5>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    dispatchFormConfig({ type: strings.CUSTOMER })
                    setModal({ ...modal, clientForm: true })
                  }}
                >
                  {t.EDIT_PROFILE}
                </Button>
              </div>
              <div className={styles.profileDetailContainer}>
                {
                  Object.keys(customerProfileData).map((key, index) => (
                    <div key={index.toString()}>
                      <p>{key}</p>
                      <p>{customerProfileData[key]}</p>
                    </div>
                  ))
                }
              </div>
            </div>
          </Card>
        )
      }
      <Tab value={tabValue} index={0}>
        <Card>
          <FilterBarModule
            title={strings.USERS}
            filters={userClientHasApproval ? [...userFilter, creditMemoApproverFilter] : userFilter}
            textLabel={'Filters'}
            columns={columns}
            receiveCustomColumn={(columns) => setColumns(columns)}
            filterParams={handleUserFilters}
            onSearch={handleUserSearch}
            btnText={canManageUsers && strings.ADD_USER}
            onBtnChange={handleUser}
          />
          <TableComponent
            data={usersList}
            keyField='userId'
            columns={columns}
            sort={true}
            loading={loading}
            totalRecords={totalRecords}
            totalPages={totalPages}
            onChangePagination={(pagination) => handlePagination(pagination)}
          />
        </Card>
      </Tab>
      <Tab value={tabValue} index={1}>
        <Card>
          <FilterBarModule
            title={strings.SETTINGS_FORM.SALES_REPRESENTATIVE}
            filters={templateFilter}
            textLabel={'Filters'}
            columns={representativeColumns}
            receiveCustomColumn={(columns) => setRepresentativeColumns(columns)}
            filterParams={(params) => console.log('filter params', params)}
            btnText={!isReadOnlyuser && strings.SETTINGS_FORM.ADD_SALES_REPRESENTATIVE}
            onBtnChange={handleSalesRepresentative}
          />
          <TableComponent
            data={salesRepresentativeList}
            columns={representativeColumns.filter(column => column.dataField !== 'sharedApplications' || salesRepUsersRef.current)}
            loading={loading}
            totalRecords={salesRepresentativeTotalRecords}
            totalPages={salesRepresentativeTotalPages}
            onChangePagination={(pagination) => getRepresentativeList(pagination)}
          />
        </Card>
      </Tab>
      <Tab value={tabValue} index={2}>
        <Card>
          <FilterBarModule
            title={strings.SETTINGS_FORM.TEMPLATE.COLLATERAL_DESCRIPTION_TEMPLATE}
            filters={templateFilter}
            textLabel={'Filters'}
            columns={templateColumns}
            receiveCustomColumn={(columns) => setTemplateColumns(columns)}
            filterParams={(params) => console.log('filter params', params)}
            btnText={!isReadOnlyuser && strings.SETTINGS_FORM.TEMPLATE.ADD_TEMPLATE}
            onBtnChange={handleTemplate}
          />
          <TableComponent
            data={templateList}
            columns={templateColumns}
            loading={loading}
            totalRecords={templateTotalRecords}
            totalPages={templateTotalPages}
            onChangePagination={(pagination) => getTemplateList(pagination)}
          />
        </Card>
      </Tab>

      {creditUsageEnabled && <Tab value={tabValue} index={3}>
        <BillingTab
            autoReplenish={autoReplenish}
            handleAutoReplenishToggle={handleAutoReplenishToggle}
            tiers={tiers}
            handleTierChange={handleTierChange}
            refreshSignal={billingRefreshKey}
        />
      </Tab>}

      {hasViewNotificationPrivileges && !hasRoxAdminRole &&
        <Tab value={tabValue} index={notificationTabIndex}>
          <Card className='p-4 cardHeight'>
            <NotificationForm />
          </Card>
        </Tab>}

        {applicationDeclineEmailEnabled && hasViewNotificationPrivileges && !hasRoxAdminRole &&
          <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Decline Email')}>
            {/* The tab draws its own card (head, form | preview, foot), so no Card wrapper here. */}
            <DeclineEmailSettingsTab />
          </Tab>}

        { docusignEnabled &&
          <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Docusign')}>
            <DocuSignForm/>
          </Tab>
        }

        { taxrockEnabled &&
          <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'TaxRock')}>
            <TaxRockForm/>
          </Tab>
        }

        {
          hubSpotIntegrationEnabled &&
          <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'HubSpot')}>
            <HubSpotForm />
          </Tab>
        }
        {!hasRoxAdminRole && (
            <>
              {canManageSecuritySettings &&
                  <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Security')}>
                    <SecurityTab />
                  </Tab>}
              {applicationFlaggingEnabled && canManageSecuritySettings &&
                  <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Flagging')}>
                    <FlaggedBusinessTypesTab />
                  </Tab>}
              <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Client Information')}>
                <ClientInformationTab />
              </Tab>
            </>
        )}
        {
          <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'MarketPlace')}>
            <FeatureFlagsForm />
          </Tab>
        }
        {admin && (
            <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Client Portal')}>
              <ClientPortalTab clientUuid={customerData?.uuid} portalFlag={customerData?.externalApplicationCreationEnabled} />
            </Tab>
        )}
        {admin && customerData?.uuid && (
            <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Feature Flags')}>
              <ClientFeatureFlagsTab
                clientUuid={customerData.uuid}
                clientName={customerData.name}
                enabledFlags={customerData.featureFlags}
                onChanged={() => getClientById(clientId)}
              />
            </Tab>
        )}
        {admin && customerData?.uuid && (
            <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Plaid Page')}>
              <ClientPlaidConfigTab clientUuid={customerData.uuid} clientName={customerData.name} />
            </Tab>
        )}
        {admin && customerData?.uuid && (
            <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Plaid Connections')}>
              <PlaidConnectionsTab clientUuid={customerData.uuid} clientName={customerData.name} />
            </Tab>
        )}
        {showDocusignTemplates && (
            <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Docusign Templates')}>
              <DocusignTemplatesTab clientUuid={customerData?.uuid} numericClientId={customerData?.clientId} />
            </Tab>
        )}
        {activityDashboardEnabled && customerAdmin && (
            <Tab value={tabValue} index={clientSettingsTab.findIndex(tab => tab.label === 'Underwriting')}>
              <UnderwritingForm />
            </Tab>
        )}

      <ClientForm
        open={modal.clientForm}
        onClose={() => {
          setModal({ ...modal, clientForm: false })
        }}
        onSubmit={handleSubmit(formData => handleClientUpdateForm(formData))}
        mode={strings.EDIT}
        loading={formLoader}
        {...props}
        creditMemoApprovalEnabled={userClientHasApproval}
      />
      <UserForm
        open={modal.userForm}
        onClose={() => {
          setModal({ ...modal, userForm: false })
          dispatch(reset('profileForm'));
        }}
        onSubmit={handleSubmit(formData => handleUserForm(formData))}
        mode={formMode}
        loading={formLoader}
        {...props}
      />
      <ReportsCostDialog
        open={modal.reportsCostDialog}
        onClose={() => {
          setModal({ ...modal, reportsCostDialog: false })
        }}
      />
      <SharedApplicationsModal
        representative={sharedWithRepresentative}
        onClose={() => {
          setSharedWithRepresentative(null)
          // Counts may have changed if something was removed
          getRepresentativeList()
        }}
      />
      <SalesRepresentativeForm
        open={modal.salesRepresentativeForm}
        onClose={() => {
          setModal({ ...modal, salesRepresentativeForm: false })
          dispatch(reset('profileForm'));
        }}
        onSubmit={handleSubmit(formData => handleSalesRepresentativeForm(formData))}
        mode={formMode}
        loading={formLoader}
        {...props}
      />
      <TemplateForm
        open={modal.templateForm}
        onClose={() => {
          setModal({ ...modal, templateForm: false })
          dispatch(reset('profileForm'));
        }}
        onSubmit={handlTemplateForm}
        mode={formMode}
        loading={formLoader}
        {...props}
      />

      <ConfirmationDialog
        open={twoFactorDialog.open}
        onClose={() => setTwoFactorDialog({ open: false, user: null })}
        onConfirm={confirmTwoFactorExemption}
        loading={loading}
        title={twoFactorDialog.user?.twoFactorExempt
          ? 'Require two-factor authentication'
          : 'Exempt from two-factor authentication'}
        message={twoFactorDialog.user?.twoFactorExempt
          ? `${twoFactorDialog.user?.email} will sign in with a password and an email code from their next sign-in.`
          : `${twoFactorDialog.user?.email} will keep signing in with a password only, even while two-factor authentication is required for the rest of the organization.`}
        confirmText={twoFactorDialog.user?.twoFactorExempt ? 'Require' : 'Exempt'}
      />

      <StripeConfirmationModal
        open={openStripeConfirmationModal}
        onClose={() => setOpenStripeConfirmationModal(false)}
        onBillingChanged={() => setBillingRefreshKey((k) => k + 1)}
      />
    </div>
  )
}

export default reduxForm({
  form: 'profileForm',
  enableReinitialize: true
})(ClientProfile)